"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const contract_type_1 = require("@app/util/contract-type");
const filtered_content_for_organization_1 = require("@app/util/filtered-content-for-organization");
const action_type_1 = __importDefault(require("../const/action-type"));
const initial_1 = __importDefault(require("../store/initial"));
exports.default = (state = initial_1.default.workspaces, action) => {
    switch (action.type) {
        case action_type_1.default.SET_WORKSPACES: {
            const workspacesWithFilteredContractTypes = action.data?.map((ws) => {
                if ('organizationId' in ws && 'contractTypes' in ws) {
                    const organizationId = ws.organizationId;
                    const enableExternalContractTypeOption = (0, filtered_content_for_organization_1.getFilteredContentForOrganization)('enable_external_contract_type', false, undefined, organizationId);
                    return {
                        ...ws,
                        contractTypes: (0, contract_type_1.filterContractTypes)(enableExternalContractTypeOption)(ws.contractTypes ?? []),
                    };
                }
                return ws;
            }) ?? [];
            return workspacesWithFilteredContractTypes;
        }
        case action_type_1.default.RESET_STORE:
            return initial_1.default.workspaces;
        default:
            return state;
    }
};
